var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"value":_vm.value,"options":_vm.options,"field":_vm.field,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"note":_vm.note,"loading":_vm.loading},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }